export const GanttChartTypes = {
  "ResGantt": "Resource Gantt Chart",
  "SimpleOrderGantt": "Simple Order Gantt Chart",
  "OrderGantt": "Order Gantt Chart",
  "SimpleResGantt": "Simple Resource Gantt Chart"
};
